import { render, staticRenderFns } from "./topTab.vue?vue&type=template&id=9cd4b706&"
import script from "./topTab.vue?vue&type=script&lang=js&"
export * from "./topTab.vue?vue&type=script&lang=js&"
import style0 from "./topTab.vue?vue&type=style&index=0&id=9cd4b706&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports